import MarkerLayer from 'layers/types/_base/MarkerLayer';
import DestinationsTreeProvider from './providers/DestinationsTreeProvider';
import BoundingBoxFilter from 'filters/BoundingBoxFilter';

const CLUSTER_ID = 'cluster_id';

let DestinationsTreeLayer = MarkerLayer.extend({
	constructor(options) {
        MarkerLayer.prototype.constructor.call(this, options);
		this._bindListener();
	},

	initialize(options) {
        this.markers = [];
        this.featuresTest = [];
		this.options.provider = new DestinationsTreeProvider(options);
		this.options.preFilters = this._initPreFilters(options.widget);
		this.options.postFilters = [];
		this.options.markersClickable = true;
		this.options.minZoom = options.minZoom !== undefined ? options.minZoom : 16;
		if (this.isAvailableZoom(this.options.minZoom)) {
			this.options.model.show();
		}
		this.options.model.activate();
		MarkerLayer.prototype.initialize.call(this, options);
		this.options.provider.load(this.widget.config.initialDestinationId);
        this.listenTo(this.widget.bus, 'LOCATION_TREE', destination => {
            this.options.provider.load(destination.regionId);
            this.remove();
            this.initialize(this.options)

        });
        this.listenTo(this.widget.bus, 'REGION_CHANGED', destination => {
            this.options.provider.load(destination.regionId);
            this.widget.config.initialDestinationId = destination.regionId;
        });

	},

	_bindListener() {
		google.maps.event.addListener(this.widget.map, 'zoom_changed', () => {
			this._processFeatures(this.featuresTest);
		});
	},

	_bindMarkerLayerEvents() {
		this.listenTo(this.options.provider, 'PROCESS_FEATURES', features => {
			this.featuresTest = features;
			this._processFeatures(features);
			this.widget.bus.trigger('LAYER_LOADED', this, features);
		});
	},

	add() {},

	_createMarkers(features) {
		this.remove();
		features.forEach(feature => {
			let marker = this.getMarkerFromId(this._getFeatureId(feature));
			if (!marker) {
				marker = this._createMarker(feature);
				this._addListeners(marker);
				this._showMarker(marker);
				this.markers.push(marker);
			}
			this.trigger('createdMarker', marker, feature);
		});
        this.widget.bus.trigger('RELOAD_LIST', this.widget.hotelMeliaList);
	},

	_clusterClicked(cluster) {
		this.clusterHelper.setClusterExpansion(cluster.properties[CLUSTER_ID]);
		this._processFeatures(this.featuresTest);
	},

	_initPreFilters(widget) {
		return [new BoundingBoxFilter(widget)];
	},

	_markerClicked(marker, e) {
		this.deselectMarker();
		this.selectMarker(marker, e);
	},

	_createMarker(feature) {
		let marker = new google.maps.Marker({
			id: this._getFeatureId(feature),
			layerId: this.options.id,
			position: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
			properties: feature.properties,
			optimized: !this.widget.config.debugEnabled,
			clickable: this.options.markersClickable,
			zIndex: this.options.markersZIndex ? this.options.markersZIndex : 1
		});
		if (feature.properties.cluster) {
			marker.setIcon(this.clusterHelper.getIconCluster(this.widget));
		} else {
			marker.setIcon(this._getIconMarker(feature.properties, 'default'));
		}
		return marker;
	}
});

export default DestinationsTreeLayer;



// WEBPACK FOOTER //
// ./src/layers/DestinationsTreeLayer.js